import { render, staticRenderFns } from "./GalleryModalForm.vue?vue&type=template&id=7ffbc45b"
import script from "./GalleryModalForm.vue?vue&type=script&lang=js"
export * from "./GalleryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports